<template>
  <div class="language-switcher"
       v-show="has_several_locales"
       :class="language_witcher_classes">
    <template v-if="has_several_locales">
      <div class="language-switcher-item">
        <div
          class="language-switcher-item-inner"
          @click="changeShown(!shown)">
          {{current_locale}}
          <chevron-down-icon :rotate="shown"/>
        </div>
      </div>
      <div
        class="language-switcher_dropdown"
        :class="dropdown_classes">
        <ul class="language-switcher_dropdown-body">
          <li v-for="locale_url in locale_urls_to_show">
            <is-link
              :is_link="locale_url.locale !== current_locale"
              :href="locale_url.url">
              {{locale_url.locale}}
            </is-link>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import locale_mixin from "../../mixins/locale_mixin";
import {ssr_document} from "../../helpers/ssr";
import IsLink from "../slots/IsLink.vue";
import ChevronDownIcon from "../icons/ChevronDownIcon.vue";

export default {
  name: "LanguageSwitcher",
  components: {IsLink, ChevronDownIcon},
  mixins: [locale_mixin],
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false
    },
    dropdown_top: {
      type: Boolean,
      default: false
    },
    hide_current_locale_from_list: {
      type: Boolean,
      default: false
    },
    thin_dropdown: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    uid_class() {
      return `language-switcher_${this._uid}`
    },
    locale_urls_to_show() {
      if (this.hide_current_locale_from_list) {
        return this.locale_urls.filter(el => el.locale !== this.current_locale)
      }
      return this.locale_urls
    },
    language_witcher_classes() {
      let classes = [this.uid_class]
      if (this.dark) {
        classes.push('dark')
      } else if (this.light) {
        classes.push('light')
      }
      if (this.thin_dropdown) {
        classes.push('thin-dropdown')
      }
      return classes
    },
    has_several_locales() {
      return this.locale_urls_to_show.length > 1
    },
    dropdown_classes() {
      return {
        shown: this.shown,
        visibility_hidden: this.visibility_hidden,
        dropdown_top: this.dropdown_top
      }
    },
  },
  data() {
    return {
      shown: false,
      visibility_hidden: true
    }
  },
  methods: {
    changeShown(bool) {
      this.shown = bool
      if (bool) {
        this.visibility_hidden = false
      } else {
        setTimeout(() => {
          this.visibility_hidden = true
        }, 300)
      }
    },
    clickOutside() {
      ssr_document.addEventListener('click', this.clickOutsideEvent)
    },
    clickOutsideEvent({target}) {
      if(target.closest(`.${this.uid_class}`)) return
      this.shown = false
      ssr_document.removeEventListener('click', this.clickOutsideEvent)
    }
  },
  watch: {
    'shown'(val) {
      val
        ? this.clickOutside()
        : ssr_document.removeEventListener('click', this.clickOutsideEvent)
    }
  }
}
</script>
